import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class NL_Overview extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Nexoid Library Overview</h2>
              <p>
                The Nexoid library is a friendly library of the most commonly
                used Nexoid API calls. These include creating and editing
                records, creating notifications sending emails and text messages
                etc.
              </p>

              <p>
                The Nexoid library is written in Node.js and uses a callback
                architecture allowing for better management of asynchronous
                code.
              </p>

              <p>
                There are two objects available to you. "NL" which is the Nexoid
                library and contacts all the functions and interface data and
                "event" which contains information about what event.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default NL_Overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Overview.js